export enum AuthErrorCode {
  UserNotConfirmedException = 'UserNotConfirmedException',
  UserNotFoundException = 'UserNotFoundException',
  UsernameExistsException = 'UsernameExistsException',
}

export interface AuthError {
  code: AuthErrorCode;
  message: string;
}

export const toAuthError = (err: unknown): AuthError => err as AuthError;
